// extracted by mini-css-extract-plugin
module.exports = {"cohortNameCell":"edlV14ql","regularCohortCell":"fX6Zs4Hc","actionsCell":"_2k-zMRJt","cohortStatusCell":"_3Wun1n0_","activeStatus":"_2KbQjxmk","inactiveStatus":"_3ETnZySG","cohortTypeCell":"_2v6QjXpr","cohortDate":"kkvd-CJ7","cohortStatusHeader":"_2JaNvY-9","actionHeader":"_3pPAlphE","firstLabel":"_3x4PqKlm","emptyContainerContent":"_2D79oqxb"};
    if(module.hot) {
      // 1754514991274
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  